function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 248 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 125.864,
    r: 124,
    style: {
      fill: "rgb(63,167,120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.538,81.977C190.18,85.619 190.18,91.535 186.538,95.178L111.935,169.78C108.293,173.423 102.377,173.423 98.734,169.78L61.433,132.479C57.79,128.836 57.79,122.92 61.433,119.278C65.076,115.635 70.991,115.635 74.634,119.278L105.349,149.964L173.366,81.977C177.009,78.334 182.924,78.334 186.567,81.977L186.538,81.977Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-circle.a38ea4a1ae4257204666ba5fe9031b04.svg";